import Tabs from './_tabs';
import Pane from './pane';

Tabs.TabsPane = Pane;

export default Tabs;
